import { inquiryDataConstants } from '../constant/inquiryData.constants';
import { inquiryData } from '../services/inquiryData.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getInquiryDataList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        inquiryData.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(inquiryDataList) { 
        return { type:  inquiryDataConstants.GET_SUCCESS,  inquiryDataList }; 
    }
}
